"use strict";
export var profileComponent = angular
    .module("skillBuilderSaaS")
    .component("profile", {
    templateUrl: "app/accounts/profile.component.html",
    controller: ["authService", "frameworkService", "sessionService", "learningPlanService", "accountsResource", "shoppingCartService", "globalizationService", "messageService", "CONST_ALLROLES", "USER_ROLES", "$cacheFactory", "$timeout", "$rootScope", "$scope", "$state", "$stateParams", "_", "$uibModal", "DTOptionsBuilder", "$translate", "$localStorage", ProfileCtrl],
    controllerAs: "vm"
});
function ProfileCtrl(authService, frameworkService, sessionService, learningPlanService, accountsResource, shoppingCartService, globalizationService, messageService, CONST_ALLROLES, USER_ROLES, $cacheFactory, $timeout, $rootScope, $scope, $state, $stateParams, _, $uibModal, DTOptionsBuilder, $translate, $localStorage) {
    var vm = this;
    vm.lang = $translate.proposedLanguage() || $translate.use();
    vm.frameworkData = frameworkService.data;
    vm.historyOpen = false;
    vm.showImpersonate = false;
    vm.profileRecord = {};
    vm.dtSearch = "";
    vm.enabledLocalizations = $localStorage.tenantSettings.enabledLocalizations;
    vm.accountDetailsLoaded = false;
    vm.loading = true;
    vm.userRoles = [];
    vm.showDelete = authService.isSuperOrSiteAdmin();
    vm.editGroups = false;
    vm.openDeleteModal = openDeleteModal;
    vm.openImpersonateModal = openImpersonateModal;
    vm.loadData = loadData;
    vm.$onInit = function () {
        $timeout(function () {
            vm.person = $stateParams.personSeq;
            console.log("ProfileCtrl.stateParams.personSeq", $stateParams.personSeq);
            //loadName();
            vm.loadData();
        }, 100);
    };
    /////////////////////////////////////////////////////////////////////////////////////////////
    //function loadName() {
    //	//pre caching name lookup (resource has cache enabled)
    //	accountsResource.getName({ personSeq: vm.person }, function (data) {
    //		if (data.value === "")
    //			return;
    //		vm.fullName = data.value;
    //		var account = {
    //			personSeq: vm.person,
    //			name: data.value
    //		};
    //		if (!$localStorage.mostRecentAccounts)
    //			vm.mostRecentAccounts = [account];
    //		else {
    //			vm.mostRecentAccounts = $localStorage.mostRecentAccounts.filter(function (obj) {
    //				return obj.personSeq !== vm.person;
    //			});
    //			vm.mostRecentAccounts.unshift(account);
    //			vm.mostRecentAccounts = vm.mostRecentAccounts.slice(0, 5);
    //		}
    //		$localStorage.mostRecentAccounts = vm.mostRecentAccounts;
    //	});
    //}
    function loadData() {
        accountsResource.get({ personSeq: vm.person }, function (result) {
            var _a, _b;
            if (result.personSeq === null) {
                vm.found = false;
                vm.loading = false;
                return;
            }
            vm.found = true;
            vm.access = result.accessLevel;
            if (vm.access === 0) {
                vm.loading = false;
                return;
            }
            vm.editGroups = vm.access === 1 && (authService.isSuperOrSiteAdmin() || authService.isGroupAdmin());
            vm.showResetPassword = vm.access === 1;
            if (authService.isOrgAdmin())
                vm.showResetPassword = vm.access === 1 && result.tenantSettingOrgAdminCanResetPassword;
            setUserRoles(result.roles);
            vm.profileRecord = result;
            //show impersonate menu?
            if (vm.frameworkData.tenantFeatures.impersonation) {
                if (!authService.authentication.userImpersonation) {
                    vm.showImpersonate = vm.access == 1 && vm.person != authService.authentication.userPersonSeq;
                }
            }
            if (vm.historyOpen)
                loadNotes();
            else
                vm.profileRecord.userModificationNotes = [];
            vm.accountDetailsLoaded = true;
            if (((_b = (_a = vm.profileRecord) === null || _a === void 0 ? void 0 : _a.selfRegistrationEnabledFields) === null || _b === void 0 ? void 0 : _b.billingInformation) && vm.profileRecord.selfRegistrationEnabledFields.billingInformation.value && vm.profileRecord.selfRegistrationEnabledFields.billingInformation.value.threeLetterISOCountryCode) {
                globalizationService.load(vm.profileRecord.selfRegistrationEnabledFields.billingInformation.value.threeLetterISOCountryCode, function (result) {
                    vm.stateProvinceLabel = result.stateProvinceLabel;
                    vm.postalZipLabel = result.postalZipLabel;
                    vm.phoneNumberMask = result.phoneNumberMask;
                    vm.postalZipMask = result.postalZipMask;
                    vm.faxNumberMask = result.faxNumberMask;
                });
            }
            else {
                //No country is selected; clear the phone and fax mask
                vm.phoneNumberMask = null;
                vm.faxNumberMask = null;
            }
            vm.loading = false;
        }, function () {
            vm.loading = false;
            messageService.error("common.genericError");
        });
    }
    ;
    vm.processModificationNotes = function () {
        if (vm.profileRecord.userModificationNotes) {
            vm.profileRecord.userModificationNotes.forEach(function (item) {
                var values = "";
                if (item.modificationValues !== "") {
                    values = JSON.parse(item.modificationValues);
                    //In the case where a group has been removed from the DB,
                    //the server returns common.notFound instead of the group name
                    //so that has to be translated separately
                    if (values["group"] === "common.notFound") {
                        values["group"] = $translate.instant(values["group"]);
                    }
                    if (item.modificationKey === "account.profile.historyTable.modificationNote.languageUpdated") {
                        values["fromValue"] = $translate.instant(values["fromValue"]);
                        values["toValue"] = $translate.instant(values["toValue"]);
                    }
                    //The roles comming from the server is a list of comma separated translation strings
                    //translate the list first before translating the key
                    if (values["roles"]) {
                        var translatedRoles = $translate.instant(values["roles"].split(","));
                        values["roles"] = Object.keys(translatedRoles).map(function (key) {
                            return translatedRoles[key];
                        }).join(", ");
                    }
                }
                item.modificationType = $translate.instant(item.modificationKey, values);
            });
        }
    };
    var setUserRoles = function (userRoles) {
        vm.userRoles = [];
        angular.forEach(userRoles, function (userRole) {
            if (userRole.name === USER_ROLES.forumModerator && !frameworkService.data.tenantFeatures.forums)
                return;
            else if (userRole.name === USER_ROLES.organizationAdmin && !frameworkService.data.tenantFeatures.organization)
                return;
            else if (userRole.name === USER_ROLES.groupAdmin && !frameworkService.data.tenant.hasGroups)
                return;
            var role = _.find(CONST_ALLROLES, { name: userRole.name });
            if (role)
                vm.userRoles.push(role);
        });
    };
    vm.toggleHistory = function () {
        vm.historyOpen = !vm.historyOpen;
        if (vm.historyOpen && vm.profileRecord.userModificationNotes.length === 0)
            loadNotes();
    };
    var loadNotes = function () {
        accountsResource.getModificationNotes({ personSeq: vm.person }, function (result) {
            vm.profileRecord.userModificationNotes = result;
            vm.processModificationNotes();
        });
    };
    //----------------------AccountInfo
    vm.openAboutMeModal = function (profileRecord) {
        var modalInstance = $uibModal.open({
            templateUrl: "app/accounts/edit/accountInformationView.html",
            controller: "AccountInformationCtrl as vm",
            scope: $scope,
            backdrop: "static",
            resolve: {
                profileRecord: function () {
                    return angular.copy(profileRecord);
                }
            }
        });
        modalInstance.result.then(function () {
            var currentLanguage = vm.profileRecord.localizationId;
            //vm.profileRecord = result;
            //vm.profileRecord.isLearner = _.some(vm.profileRecord.roles, {
            //	name: "Learner"
            //});
            vm.loadData();
            if (authService.currentUserPersonSeq() === vm.profileRecord.personSeq) {
                $rootScope.$broadcast("updateCurrentUserData", {
                    firstName: vm.profileRecord.firstName,
                    lastName: vm.profileRecord.lastName
                });
                if (currentLanguage !== vm.profileRecord.localizationId) {
                    vm.setLocale(vm.profileRecord.localizationId);
                }
            }
        }).catch(angular.noop);
    };
    //-----------------------billing info modal
    vm.openUpdateAddressInfoModal = function () {
        var modalInstance = $uibModal.open({
            templateUrl: "app/accounts/edit/billingInformationView.html",
            controller: "BillingInformationCtrl as vm",
            scope: $scope,
            backdrop: "static",
            resolve: {
                profileRecord: function () {
                    return angular.copy(vm.profileRecord);
                }
            }
        });
        modalInstance.result.then(function (labels) {
            vm.postalZipLabel = labels.postalCodeLabel;
            vm.stateProvinceLabel = labels.provinceLable;
            vm.loadData();
        }).catch(angular.noop);
    };
    //-----------------------Personal info modal
    vm.openUpdatePersonalInfoModal = function () {
        var modalInstance = $uibModal.open({
            templateUrl: "app/accounts/edit/personalInformationView.html",
            controller: "PersonalInformationCtrl as vm",
            scope: $scope,
            backdrop: "static",
            resolve: {
                profileRecord: function () {
                    var profile = angular.copy(vm.profileRecord);
                    profile.phoneMask = vm.phoneNumberMask;
                    profile.faxMask = vm.faxNumberMask;
                    return profile;
                }
            }
        });
        modalInstance.result.then(function () {
            vm.loadData();
        }).catch(angular.noop);
    };
    vm.setLocale = function (localizationId) {
        var localization = _.find(vm.enabledLocalizations, {
            id: localizationId
        });
        frameworkService.setLocale(localization.languageCulture, localizationId, localization.name, function () {
            $state.reload();
        });
    };
    vm.openEditGroupsModal = function (profileRecord) {
        var modalInstance = $uibModal.open({
            templateUrl: "app/accounts/edit/assignedGroupsView.html",
            controller: "AssignedGroupsCtrl as vm",
            scope: $scope,
            backdrop: "static",
            resolve: {
                profileRecord: function () {
                    return angular.copy(profileRecord);
                }
            }
        });
        modalInstance.result.then(function (updatedGroupsList) {
            vm.profileRecord.groups = updatedGroupsList;
            vm.loadData();
        }).catch(angular.noop);
    };
    //--------------------Reset Password---------------------------
    vm.openResetPasswordModal = function (profileRecord) {
        var modalInstance = $uibModal.open({
            templateUrl: "app/accounts/edit/resetPasswordView.html",
            controller: "ResetPasswordCtrl as vm",
            scope: $scope,
            backdrop: "static",
            resolve: {
                profileRecord: function () {
                    return angular.copy(profileRecord);
                }
            }
        });
        modalInstance.result.then(function () {
            vm.loadData();
        }).catch(angular.noop);
    };
    function openImpersonateModal() {
        var modal = $uibModal.open({
            templateUrl: "impersonateConfirmation.html",
            backdrop: false,
            animation: false,
            windowClass: "confirmation-modal"
        });
        modal.result.then(function () {
            authService.impersonate(vm.profileRecord.userName).then(function () {
                sessionService.init();
                frameworkService.updateData();
                if (frameworkService.data.tenantFeatures.storefront) {
                    delete $localStorage.storefrontCart3;
                    shoppingCartService.synchronizeShoppingCart();
                }
                learningPlanService.data = {};
                $rootScope.$broadcast("reloadMenu");
                $rootScope.$broadcast("RefreshUserNotifications");
                $state.go("main.learningPlan");
            }).catch(angular.noop);
        }).catch(angular.noop);
    }
    function openDeleteModal() {
        var modal = $uibModal.open({
            component: "deleteAccount",
            backdrop: false,
            animation: false,
            windowClass: "confirmation-modal",
            resolve: {
                account: {
                    firstName: vm.profileRecord.firstName,
                    lastName: vm.profileRecord.lastName,
                    personSeq: vm.profileRecord.personSeq
                }
            }
        });
        modal.result.then(function (model) {
            model.id = vm.profileRecord.id;
            accountsResource.deleteUser(model, function () {
                messageService.success("common.success");
                $cacheFactory.get("$http").removeAll();
                $localStorage.mostRecentAccounts = vm.mostRecentAccounts.slice(1);
                $state.go("main.people.accounts");
            }, function (error) {
                messageService.error(error);
            });
        }).catch(angular.noop);
    }
    //----------------Account Settings--------------
    vm.openAccountSettingsModal = function (profileRecord) {
        var modalInstance = $uibModal.open({
            templateUrl: "app/accounts/edit/accountSettingsView.html",
            controller: "AccountSettingsCtrl as vm",
            scope: $scope,
            backdrop: "static",
            resolve: {
                profileRecord: function () {
                    return angular.copy(profileRecord);
                }
            }
        });
        modalInstance.result.then(function () {
            //vm.profileRecord = result;
            //vm.profileRecord.isLearner = _.some(vm.profileRecord.roles, {
            //	name: "Learner"
            //});
            vm.loadData();
        }).catch(angular.noop);
    };
    //------------Profile History Table -----------------------
    vm.dtOptions = DTOptionsBuilder.newOptions()
        .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
        .withOption("processing", true)
        .withOption("responsive", { details: { type: "column" } })
        .withOption("order", [0, "desc"])
        .withPaginationType("full_numbers")
        .withDOM("lftip")
        .withBootstrap();
    //------------Custom Questions -----------------------
    vm.getAnswerForQuestion = function (question) {
        var answerId = parseInt(question.answer);
        var answer = _.find(question.answers, { id: answerId });
        if (!answer)
            return "";
        return answer.name;
    };
    vm.getAnswer = function (question) {
        if (question.typeId === 1)
            return vm.getAnswerForQuestion(question);
        if (question.typeId === 2 && question.answer) {
            return moment.utc(question.answer).format("LL");
        }
        return question.answer;
    };
}
